import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import BrandCarousel from "./components/BrandCarousel";
import PopularSearches from "./components/PopularSearches";
import Footer from "./components/Footer";
import Brands from "./components/Brands";
import Blog from "./components/Blog";
import About from "./components/About";
import Contact from "./components/Contact";

const AppContent = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const [searchResults, setSearchResults] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const handleSearch = async (query) => {
    if (!query.trim()) return;
    try {
      setLoading(true);
      const response = await fetch(`https://qf-v1.onrender.com/search?query=${encodeURIComponent(query)}`);
      if (!response.ok) throw new Error("Search failed");
      const data = await response.json();
      setSearchResults(data);
    } catch (error) {
      console.error("Error during search:", error);
      setSearchResults([]); // fallback
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {isHomePage && <Hero onSearch={handleSearch} />}
      <Routes>
        <Route path="/brands" element={<Brands />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      {isHomePage && (
        <>
          {searchResults.length > 0 ? (
            <div style={{ padding: "2rem" }}>
              <h2>Search Results</h2>
              <div className="search-results-grid">
                {searchResults.map((item) => (
                  <div key={item.item_id} className="search-card">
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      <img
                        src={item.image.startsWith('http') ? item.image : `https:${item.image}`}
                        alt={item.title}
                        className="search-card-image"
                      />
                      <h3>{item.title}</h3>
                      <p>${item.price}</p>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <>
              {!loading && (
                <>
                  <BrandCarousel />
                  <PopularSearches />
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};



const App = () => {
  return (
    <Router>
      <Navbar />
      <AppContent />
      <Footer />
    </Router>
  );
};

export default App;

